<template>
  <div class="full-screen-bank-search-page">
    <popup ref="popup"
      fullScreen
      :visible="true"
      :title="gettext('银行名称')"
      cancelTxt=""
      confirmTxt="">
      <!-- 搜索框 -->
      <div class="full-screen-bank-search-bar">
        <div class="full-screen-bank-search-input">
          <rich-input
            v-model="keyword"
            :placeholder="gettext('请输入银行名称或五十音')"
            clearable
          >
            <i class="richic-search" slot="prepend"></i>
          </rich-input>
        </div>
        <span class="cancel-btn" @click="hide">{{gettext('取消')}}</span>
      </div>
      <!-- 搜索结果 -->
      <div class="full-screen-bank-search-result">
        <rich-loading v-show="loading"></rich-loading>
        <div class="full-screen-bank-search-scroll-wrap" v-if="!loading">
          <rich-result-page
            type="empty"
            v-show="result.length === 0 && loaded"
          />
          <rich-scroll ref="searchScroll" v-if="result.length > 0">
            <div class="full-screen-bank-search-list-inner-wrap">
              <ul class="full-screen-bank-search-list">
                <li
                  class="full-screen-bank-search-list-item"
                  v-for="(item, index) in result"
                  :key="index">
                  <rich-cell
                    @click="clickSearchItem(item)"
                    :key="index"
                    :title="item.value">
                  </rich-cell>
                </li>
                <slot></slot>
              </ul>
            </div>
          </rich-scroll>
        </div>
      </div>
    </popup>
  </div>
</template>
<script>
import Popup from './Popup'
import { debounce } from '@/common/utils/util'
import { getShopCommonConfig } from '@/api'

export default {
  name: 'FullScreenBankSearch',
  components: {
    Popup
  },
  data () {
    return {
      loading: false,
      loaded: false,
      keyword: '',
      result: []
    }
  },
  watch: {
    keyword (nVal) {
      if (nVal.length >= 0) {
        this.search(nVal)
      }
    }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
    },
    search: debounce(async function (keyword) {
      this.loading = true
      this.loaded = false
      getShopCommonConfig({
        type: 'bankMap',
        withBankList: 1, // 如果为1，表示bank返回的是有序的数组，0返回对象，对象格式为兼容历史版本
        bankName: keyword
      }).then(res => {
        this.result = res.data || []
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    }, 800),
    clickSearchItem (item) {
      this.$emit('select', item)
    }
  },
  mounted () {
    this.search('')
  }
}
</script>

<style lang="scss">
.full-screen-bank-search-page {
  overflow: hidden;
  height: 100%;
  position: relative;

  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }

  .full-screen-bank-search-bar {
    position: relative;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 20px 0 20px 20px;
    z-index: 1;
    height: 100px;
    background: #FFF;
    .rich-input {
      width: 100%;
      color: $color-light-grey;
      height: initial !important;
      &::placeholder {
        color: $color-light-grey;
      }
    }
    .rich-input-wrapper {
      flex: 1;
      .rich-input-label-placeholder {
        height: 0;
      }
    }
    .cancel-btn {
      padding: 20px;
      font-size: $fontsize-large;
      color: $color-light-grey;
    }
    .full-screen-bank-search-input {
      background: $color-col-line;
      height: 80px;
      display: flex;
      flex: 1;
      .richic-search {
        display: block;
        line-height: 80px;
        font-size: 36px;
        color: $color-light-grey;
        padding: 0 16px;
      }
    }
  }
  .rich-loading-spinners {
    margin: 30px auto;
  }
  .full-screen-bank-search-scroll-wrap {
    position: absolute;
    top: 100px;
    bottom: 0;
    width: 100%;
    .full-screen-bank-search-list-inner-wrap {
      padding-bottom: 60px;
    }
  }
  .full-screen-bank-search-list {
    padding: 0 20px;
    .rich-cell-title {
      text-align: left;
    }
  }
}
</style>
